// src/utils/errors.ts
var InvalidUrlError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidUrlError";
  }
};
var InvalidStringError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidStringError";
  }
};
var EmptyStringError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "EmptyStringError";
  }
};
var UndefinedOrNullError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "UndefinedOrNullError";
  }
};
var StringOutOfRangeError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "StringOutOfRangeError";
  }
};
var NonceError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "NonceError";
  }
};
var CsrfError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "CsrfError";
  }
};
var InvalidHttpTokenResponseError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidHttpTokenResponseError";
  }
};
var InvalidURLSearchParamsError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidURLSearchParamsError";
  }
};
var MissingSearchCodeParamError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "MissingSearchCodeParamError";
  }
};
var MissingSearchStateParamError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "MissingSearchStateParamError";
  }
};
var AuthCodeNotFoundError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "AuthCodeNotFoundError";
  }
};
var InvalidAuthCodeError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidAuthCodeError";
  }
};
var CsrfNotFoundError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "CsrfNotFoundError";
  }
};
var FetchTokenResponseError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "FetchTokenResponseError";
  }
};
var GetCheckMigratedFlagResponseError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "GetCheckMigratedFlagResponseError";
  }
};
var GetRefreshTokenResponseError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "GetRefreshTokenResponseError";
  }
};
var SetRefreshTokenResponseError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "SetRefreshTokenResponseError";
  }
};
var GetProfileResponseError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "GetProfileResponseError";
  }
};
var LogoutError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "LogoutError";
  }
};
var DecodeJwtError = class _DecodeJwtError extends Error {
  constructor(message) {
    super(message);
    this.name = "DecodeJwtError";
    Error.captureStackTrace(this, _DecodeJwtError);
  }
};
var JwtValidationError = class _JwtValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = "JwtValidationError";
    Error.captureStackTrace(this, _JwtValidationError);
  }
};
var StatusCode1xxError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "StatusCode1xxError";
  }
};
var StatusCode3xxError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "StatusCode3xxError";
  }
};
var StatusCode4xxError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "StatusCode4xxError";
  }
};
var StatusCode5xxError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "StatusCode5xxError";
  }
};
var EnvironmentNotGivenError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "EnvironmentNotGivenError";
  }
};

export {
  InvalidUrlError,
  InvalidStringError,
  EmptyStringError,
  UndefinedOrNullError,
  StringOutOfRangeError,
  NonceError,
  CsrfError,
  InvalidHttpTokenResponseError,
  InvalidURLSearchParamsError,
  MissingSearchCodeParamError,
  MissingSearchStateParamError,
  AuthCodeNotFoundError,
  InvalidAuthCodeError,
  CsrfNotFoundError,
  FetchTokenResponseError,
  GetCheckMigratedFlagResponseError,
  GetRefreshTokenResponseError,
  SetRefreshTokenResponseError,
  GetProfileResponseError,
  LogoutError,
  DecodeJwtError,
  JwtValidationError,
  StatusCode1xxError,
  StatusCode3xxError,
  StatusCode4xxError,
  StatusCode5xxError,
  EnvironmentNotGivenError
};
